import * as methods from '../methods';
import { Resource } from '../Resource';
const rootPath = 'oad/water_balance';
export var WaterBalanceSoilType;
(function (WaterBalanceSoilType) {
    WaterBalanceSoilType["clay"] = "Argile";
    WaterBalanceSoilType["siltyClay"] = "Argile limoneuse";
    WaterBalanceSoilType["sandyClay"] = "Argile sableux";
    WaterBalanceSoilType["clayeySilt"] = "Limon argileux";
    WaterBalanceSoilType["clayeySandyLoam"] = "Limon argileux sableux";
    WaterBalanceSoilType["mediumSilt"] = "Limon moyen";
    WaterBalanceSoilType["sandyMediumSilt"] = "Limon moyen sableux";
    WaterBalanceSoilType["sandySilt"] = "Limon sableux";
    WaterBalanceSoilType["sandyClayeyLaom"] = "Limon sableux argileux";
    WaterBalanceSoilType["siltySand"] = "Sable Limoneux";
    WaterBalanceSoilType["clayeySand"] = "Sable argileux";
})(WaterBalanceSoilType || (WaterBalanceSoilType = {}));
const toRaw = {
    configure: ({ soilType, plotId, availableWaterCapacity }) => ({
        plot: plotId,
        soil_type: soilType,
        ru: availableWaterCapacity
    })
};
const fromRaw = {
    getConfig: ({ plot, soil_type, ru }) => ({
        soilType: soil_type,
        plotId: plot,
        availableWaterCapacity: ru
    }),
    result: (x) => x,
    getAvailableWaterCapacityPerSoilType: (x) => x
};
const waterBalance = Resource((requesterBuilder) => {
    const result = (query) => methods.get({
        requesterBuilder,
        rootPath: `${rootPath}/result`,
        fromRaw: fromRaw.result,
        params: {
            query: {
                crop: query?.cropId,
                before: query?.before
            }
        }
    })();
    return {
        configure: methods.create({
            rootPath: `${rootPath}/config`,
            requesterBuilder,
            fromRaw: fromRaw.getConfig,
            toRaw: toRaw.configure,
            buildKeysToInvalidate: () => [result().invalidationKey]
        }),
        getConfig: (query) => methods.get({
            requesterBuilder,
            rootPath: `${rootPath}/config`,
            fromRaw: fromRaw.getConfig,
            params: {
                query: {
                    plot: query?.plotId
                }
            }
        })(),
        getAvailableWaterCapacityPerSoilType: (query) => methods.get({
            requesterBuilder,
            rootPath: `${rootPath}/ru`,
            fromRaw: fromRaw.getAvailableWaterCapacityPerSoilType,
            params: {
                query: {
                    plot: query?.plotId
                }
            }
        })(),
        result,
        export: (query) => requesterBuilder({
            path: `${rootPath}/export`,
            requestCtx: {
                method: 'GET',
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                parse: (x) => x.blob(),
                transform: (blob) => blob,
                params: {
                    query: {
                        crop: query?.cropId,
                        before: query?.before
                    }
                }
            }
        })
    };
});
export default waterBalance;
